import { StdContentComponent } from './dashboard/std-content/std-content.component';
import { TchrContentComponent } from './dashboard/tchr-content/tchr-content.component';
import { PplContentComponent } from './dashboard/ppl-content/ppl-content.component';
import { OwnerContentComponent } from './dashboard/owner-content/owner-content.component';
import { HraContentComponent } from './dashboard/hra-content/hra-content.component';
import { TrpContentComponent } from './dashboard/trp-content/trp-content.component';
import { RecContentComponent } from './dashboard/rec-content/rec-content.component';
import { ConsContentComponent } from './dashboard/cons-content/cons-content.component';
import { StudentDashboard } from './dashboard/student-dashboard/student-dashboard';

import { FileUploadComponent } from '../common/file-upload-old/file-upload.component';
import { CouponsComponent } from '../common/coupons/coupons.component';
import { ModulesComponent } from '../common/modules/modules.component';
import { Notifications } from '../common/notifications/notifications';
// import { TelephoneDirectoryComponent } from '../common/telephone-directory/telephone-directory.component';
import { TelephoneDirectory } from '../common/telephone-directory/telephone-directory';
import { HelpDesk } from '../common/help-desk/help-desk';
import { ExcelImportExportComponent } from '../common/excel-import-export/excel-import-export.component';
import { MenuItemsSettingsComponent } from '../common/menu-items-settings/menu-items-settings.component';
// import { StudentPromotion } from '../common/student-promotion/student-promotion';
import { StudentMigrationPromotionComponent } from '../common/student-promotion/student-migration-promotion.component';

import { DemoListComponent } from './demos/demo-list/demo-list.component';
import { TrialInfoComponent } from './demos/trial-info/trial-info.component';
import { KycWizardComponent } from './demos/kyc-wizard/kyc-wizard.component';
import { KycPaymentComponent } from '../components/demos/kyc-payment/kyc-payment.component';
import { PaymentReceiptComponent } from '../components/demos/payment-receipt/payment-receipt';

import { UserListComponent } from '../components/users/user-list/user-list.component';
import { UserFormComponent } from '../components/users/user-form/user-form.component';
import { OrgListComponent } from '../components/organization/org-list/org-list.component';
import { OrgFormComponent } from '../components/organization/org-form/org-form.component';
import { OrgViewComponent } from '../components/organization/org-view/org-view.component';

import { InqListComponent } from './inquery/inq-list/inq-list.component';
import { FollowUpsComponent } from '../components/inquery/follow-ups/follow-ups.component';
import { FollowUpsFormComponent } from '../components/inquery/follow-ups-form/follow-ups-form.component';
import { InqViewComponent } from '../components/inquery/inq-view/inq-view.component';
import { EligibilityCheck } from '../components/eligibility-check/eligibility-check';
import { EligibilitySetup } from '../components/eligibility-setup/eligibility-setup';

import { InstListComponent } from '../components/institute/inst-list/inst-list.component';
import { StaffListComponent } from '../components/staff/staff-list/staff-list.component';
import { StaffFormComponent } from '../components/staff/staff-form/staff-form.component';
import { StaffViewComponent } from '../components/staff/staff-view/staff-view.component';

import { ApplicationListComponent } from '../components/applications/application-list/application-list.component';
import { ApplicationFormComponent } from '../components/applications/application-form/application-form.component';
import { AdmissionListComponent } from '../components/admissions/admission-list/admission-list.component';
import { AdmissionFormComponent } from '../components/admissions/admission-form/admission-form.component';

import { PkgMasterComponent } from '../components/pkg-master/pkg-master.component';
import { MyProfileComponent } from '../components/my-profile/my-profile.component';
import { ContactMessages } from '../components/contact-messages/contact-messages';
import { ActivityLog } from '../components/activity-log/activity-log';

// import { AgreementComponent } from '../common/agreement/agreement.component';
import { FeeManagement } from '../modules/fee-management/fee-management';
import { Attendance } from '../modules/attendance/attendance';
import { TimetableComponent } from '../modules/timetable/timetable';
import { Transport } from '../modules/transport/transport';
import { Library } from '../modules/library/library';
import { Examination } from '../modules/examination/examination';
import { GatePass } from '../modules/gate-pass/gate-pass';
import { Finance } from '../modules/finance/finance';
import { Inventory } from '../modules/inventory/inventory';
import { HrAdminComponent } from '../modules/hr-admin/hr-admin';
import { Homework } from '../modules/homework/homework';


export const CONTENT_COMPONENTS = [
  ModulesComponent, CouponsComponent, PkgMasterComponent, MyProfileComponent,
  StdContentComponent, TchrContentComponent, PplContentComponent, OwnerContentComponent, 
  HraContentComponent, TrpContentComponent, RecContentComponent, ConsContentComponent,
  FileUploadComponent, Notifications, TelephoneDirectory, ContactMessages, 
  ActivityLog, ExcelImportExportComponent, MenuItemsSettingsComponent, StudentDashboard,
  StudentMigrationPromotionComponent
];
export const MAIN_COMPONENTS = [
  DemoListComponent, TrialInfoComponent, KycWizardComponent, KycPaymentComponent, PaymentReceiptComponent,
  UserListComponent, UserFormComponent, OrgListComponent, OrgFormComponent, OrgViewComponent, InqListComponent, 
  FollowUpsComponent, FollowUpsFormComponent, InqViewComponent, EligibilityCheck, EligibilitySetup, 
  InstListComponent, StaffListComponent, StaffFormComponent, StaffViewComponent, FeeManagement, Attendance,
  ApplicationListComponent, ApplicationFormComponent, AdmissionListComponent, AdmissionFormComponent,
  TimetableComponent, Transport, Library, Examination, GatePass, Finance, Inventory, HrAdminComponent, 
  Homework
];

export const MAP_COMPONENTS: Record<string, any> = {
  org: OrgListComponent,
  int: InstListComponent,
  inq: InqListComponent,
  dmo: DemoListComponent,
  mod: ModulesComponent,
  cpn: CouponsComponent,
  adf: AdmissionListComponent,
  slg: EligibilitySetup,
  fee: FeeManagement,
  dir: TelephoneDirectory,
  ttl: TimetableComponent,
  stf: StaffListComponent,
  sgp: GatePass,
  att: Attendance,
  trp: Transport,
  usr: UserListComponent,
  apl: ApplicationListComponent,
  lib: Library,
  xam: Examination,
  inv: Inventory,
  mal: Finance,
  pkg: PkgMasterComponent,
  hra: HrAdminComponent,
  hlp: HelpDesk,
  shw: Homework,
  alog: ActivityLog,
  mnus: MenuItemsSettingsComponent,
  prom: StudentMigrationPromotionComponent
};
